// Поиск по людям: слово запроса совпадает с НАЧАЛОМ слова, а не с любым местом.
//
// ЗАЧЕМ. «Савельев Г» возвращал «Савельеву Алену Олеговну»: буква «г» есть
// внутри «Олеговна». Инициал перестал сужать выдачу, а именно им и уточняют
// однофамильцев (жалоба владельца 19.08). Сервер уже ищет так же
// (`nameWordPrefixCondition` в core/client-search) — здесь то же правило для
// списков, которые фильтруются в памяти.
//
// Для НАЗВАНИЙ (группы, товары, направления) правило не годится: там ищут по
// куску слова — «hop» в «Hip-Hop», — и подстрока остаётся уместной.

/** Каждое слово запроса начинает какое-нибудь слово в строке. */
export function matchesNameQuery(haystack: string | null | undefined, query: string): boolean {
  const tokens = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return true;
  const words = (haystack ?? '')
    .toLowerCase()
    .split(/[^\p{L}\p{N}]+/u)
    .filter(Boolean);
  return tokens.every((t) => words.some((w) => w.startsWith(t)));
}
